module.exports = __webpack_public_path__ + "static/media/msp_24.7254af77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_24.png
// module id = 192
// module chunks = 1